import { render, staticRenderFns } from "./CourseReview.vue?vue&type=template&id=611f3b39&"
import script from "./CourseReview.vue?vue&type=script&lang=js&"
export * from "./CourseReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports